import { Map } from 'immutable'

import { AUTH_ERROR } from '../actions'

export const initialState = new Map({
  error: null
})

const error = (state = initialState, action) => {
  switch (action.type) {
    case AUTH_ERROR:
      try {
        return state.set('error', action.data.detail)
      } catch (e) {
        return state.set('error', 'Unable to login')
      }
    default:
      return state
  }
}

export default error
